module.exports = __webpack_public_path__ + "img/dl2614_1.prt.1692b43c.jpg";